// extracted by mini-css-extract-plugin
export default {"vsContainer":"VSReader__vsContainer--V7krzriith","hide":"VSReader__hide--CL_9CDdmu_"};